<template>
    <breadCrumbs title="Form Wizard" main="Form Layout" title1="Form Wizard" />
          <div class="container-fluid text-start">
            <div class="row">
                <SimpleWizard/>
            </div>
          </div>
</template>
<script>
import SimpleWizard from "./SimpleWizard2.vue"
export default {
    components:{
        SimpleWizard
    }
}
</script>